/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowRequestManagementAttributeMapping {
    getFixupPrototypeFunction() { return ServiceNowRequestManagementAttributeMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowRequestManagementAttributeMapping>): ServiceNowRequestManagementAttributeMapping {
        let obj = Object.assign(new ServiceNowRequestManagementAttributeMapping(), model);
        ServiceNowRequestManagementAttributeMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowRequestManagementAttributeMapping>): ServiceNowRequestManagementAttributeMapping {
        if (!model) return null;
        return ServiceNowRequestManagementAttributeMapping.newInstance(<ServiceNowRequestManagementAttributeMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowRequestManagementAttributeMapping) {
        if (!obj) return;

        models.ServiceNowRequestManagementAttributeMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowRequestManagementAttributeMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowRequestManagementAttributeMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ServiceNow attribute for Request management
     */
    service_now_attribute: string;

    /**
     * List of Corestack attributes for Request Management
     */
    corestack_attribute: Array<string>;

}
